module.exports = __webpack_public_path__ + "static/media/cv-library-premium-no-bg.f8989559.svg";